export default "__VITE_ASSET__Cc2rohnx__"